import { Log, UserManager } from 'oidc-client';
import CognitoUserManager from './CognitoUserManager';
import CognitoMetadataService from './MetadataServiceCtors/CognitoMetadataService';
import DefaultMetadataService from './MetadataServiceCtors/DefaultMetadataService';
import SSOLogoutBySession from './MetadataServiceCtors/SSOLogoutBySession';

const createUserManager = (settings) => {
  const userManagerConfig = {


    ...settings,
    clockSkew: 4500,
  };



  let userManagerClass;

  switch (process.env.REACT_APP_AUTH_USERMANAGER_IMPL || 'CognitoUserManager') {
    case 'CognitoUserManager':
      userManagerClass = new CognitoUserManager({
        ...userManagerConfig,
        MetadataServiceCtor: CognitoMetadataService,
      });
      break;
    default:
      userManagerClass = new UserManager({
        ...userManagerConfig,
        MetadataServiceCtor: SSOLogoutBySession,
      });
      break;
  }

  const userManager = userManagerClass;

  userManager.events.addSilentRenewError((e) => {
    Log.debug('addSilentRenewError', e);
    setTimeout(() => {
      userManager.getUser();
    }, 2000);
  });

  userManager.events.addAccessTokenExpired(() => {
    Log.debug('addAccessTokenExpired');

    if (userManager.settings.automaticSilentRenew) {
      userManager.signinSilent().catch((error) => Log.debug(error));
    }
  });

  return userManager;
};

export default createUserManager;
